import {decrementIssuesTabCounter} from '@github-ui/issues-tab-counter'
import {useMutation, type UseMutationResult} from '@github-ui/react-query'
import {deleteIssueMutation as deleteIssueMutationQueryId} from '@github-ui/server-persisted-queries'
import type {DeleteIssueMutationMutation} from '@github-ui/server-persisted-queries/types/deleteIssueMutation'

import {issueLifecyclePath, submitIssueLifecycleMutation} from './issue-lifecycle-mutation'

export function useDeleteIssueMutation({
  owner,
  repository,
  number,
  onCompleted,
  onError,
}: {
  owner: string
  repository: string
  number: number
  onCompleted?: () => void
  onError?: (error: Error) => void
}): UseMutationResult<DeleteIssueMutationMutation, Error, void> {
  return useMutation({
    mutationFn: () => submitDeleteIssueMutation({owner, repository, number}),
    onSuccess: () => {
      onCompleted?.()
      decrementIssuesTabCounter()
    },
    onError,
  })
}

export function submitDeleteIssueMutation({
  owner,
  repository,
  number,
}: {
  owner: string
  repository: string
  number: number
}) {
  return submitIssueLifecycleMutation<DeleteIssueMutationMutation>({
    path: `${issueLifecyclePath(owner, repository, number)}.json`,
    method: 'DELETE',
    queryId: deleteIssueMutationQueryId,
    errorMessage: 'Issue deletion failed',
    isSuccess: data => data.deleteIssue?.issue != null,
  })
}
